import { Injectable, EventEmitter } from '@angular/core';
import { fromEvent } from 'rxjs';

@Injectable()
export class ConnectionStateService {
  public connectionRestored = new EventEmitter<void>();

  public get online(): boolean {
    return this._online;
  }

  private _online: boolean;

  constructor() {
    this.initOnlineTriggers();
  }

  private initOnlineTriggers(): void {
    fromEvent(window, 'online').subscribe(this.handleOnline.bind(this));
    fromEvent(window, 'offline').subscribe(this.handleOffline.bind(this));
    this._online = navigator.onLine;
  }

  private handleOnline(): void {
    if (!this._online) {
      this.connectionRestored.emit();
    }

    this._online = true;
  }

  private handleOffline(): void {
    this._online = false;
  }
}
